module.exports = (__parcel__import__("2SBni")).then(() => parcelRequire('2ipug'));